export const HISTORICAL_DATA_IMPORT_LIST_PATH =
  "/settings-menu/historical-data-import";
